var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 150,
    viewBox: "0 0 151 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 417"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 75.5,
    cy: 75,
    rx: 75,
    ry: 75,
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.4564 31.249C77.4953 31.249 80.4098 32.4562 82.5587 34.6051C84.7075 36.754 85.9147 39.6684 85.9147 42.7074V77.0824C85.9147 80.1213 84.7075 83.0358 82.5587 85.1846C80.4098 87.3335 77.4953 88.5407 74.4564 88.5407C71.4174 88.5407 68.503 87.3335 66.3541 85.1846C64.2053 83.0358 62.998 80.1213 62.998 77.0824V42.7074C62.998 39.6684 64.2053 36.754 66.3541 34.6051C68.503 32.4562 71.4174 31.249 74.4564 31.249ZM74.4564 99.999C71.5359 100.002 68.7269 101.121 66.6032 103.125C64.4796 105.13 63.2016 107.87 63.0305 110.786C62.8593 113.701 63.8079 116.572 65.6823 118.812C67.5568 121.051 70.2157 122.491 73.1158 122.835L74.4793 122.916C77.3998 122.912 80.2088 121.794 82.3325 119.789C84.4561 117.784 85.7341 115.044 85.9052 112.129C86.0764 109.213 85.1278 106.343 83.2533 104.103C81.3789 101.863 78.72 100.424 75.8199 100.079L74.4564 99.999Z",
    fill: "#DD2025"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseError);
export default __webpack_public_path__ + "static/media/base_error.fcb1862624af735cf089986e18e25890.svg";
export { ForwardRef as ReactComponent };